import React from 'react';
import { Grid } from '@material-ui/core';

import RecipeCard from 'components/recipes/cards/RecipeCard';

const RecipesList = ({ recipes }) => {
  return (
    <Grid container direction="column">
      {recipes.map((recipe, index) => {
        return (
          <Grid
            item
            key={recipe.id}
            container
            style={{ marginTop: index > 0 ? 24 : 0 }}
          >
            <RecipeCard recipeModel={recipe}></RecipeCard>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default RecipesList;
